// npm
import moment from 'moment'
import { get } from 'lodash'
//
import i18n from '@/lang'

function formatDateIso (date) {
  return date && moment(date).utc(true).format('YYYY-MM-DD')
}

function translate (prefix, value, defaultValue) {
  return (value) => {
    const key = value || defaultValue
    const fullKey = `${prefix}.${key}`
    const hasKey = i18n.te(fullKey)
    return hasKey ? i18n.t(fullKey) : key
  }
}

const columnsRenderer = {
  'flightDate': formatDateIso,
  'depPortLabels.code': null,
  'arrPortLabels.code': null,
  'orderData.fullName': null,
  'orderData.docNum': null,
  'orderData.mvz': null,
  'organization': null,
  'birthDate': formatDateIso,
  'orderData.contacts': null,
  'orderData.email': null,
  'orderData.timeFrom': null,
  'processData.orderStatus': translate('flight-orders.processState', 'noState')
}

const slotColumns = ['register', 'medcheck']

export function renderColumns (object, columns) {
  let values = columns.map(key => {
    if (slotColumns.includes(key)) {
      return {
        key,
        slotName: 'column-' + key,
        useSlot: true
      }
    }
    const rawValue = get(object, key, '')
    const renderer = columnsRenderer[key]
    const value = (renderer && renderer(rawValue)) || rawValue || ''
    return {
      key,
      value
    }
  })
  // console.table(values)
  return values
}



// WEBPACK FOOTER //
// ./src/components/flight-orders/scrolled/flightOrderRowRenderer.js